/* eslint-disable no-console */
import firebase from 'firebase'
import 'firebase/firebase-firestore'
import * as constants from '../../../constants.json'

export default {
  state: {
    loadedCompanies: [],
    companyData: '',
    companyInfo: {},
    currency: ''
  },

  mutations: {
    /**
     * Mutation method that add a new company object to `state.loadedCompanies`.
     * @param {object} state    - The state property.
     * @param {object} status  - The company status.
     */
    mutationSetCompanyData (state, payload) {
      state.companyData = payload
    },

    /**
     * Mutation method that load all companies fetched from database to `state.loadedCompanies`.
     * @param {object} state    - The state property.
     * @param {array} payload   - Array of category objects.
     */
    mutationLoadedCompanies (state, payload) {
      state.loadedCompanies = payload
    },

    /**
     * Mutation method tha delete a company object from 'state.loadedCategories'.
     * @param {object} state    - The state property.
     * @param {string} payload  - The company Id.
     */
    mutationDeleteLoadedCompany (state, companyId) {
      state.loadedCompanies.splice(state.loadedCompanies.findIndex(company => company.companyId === companyId), 1)
    },

    /**
     * Mutation method that load the company data to state.
     * @param {*} state
     * @param {*} companyInfo
     */
    mutationLoadBotInfo (state, companyInfo) {
      state.companyInfo = { ...companyInfo }
    }
  },

  actions: {

    /**
     * Adding a new company data.
     * @param {*} payload -Contains the following properties: companyName, description and creationDate.
     */
    async actionAddCompany ({ commit }, payload) {
      console.log('payload', payload)
      commit('mutationSetLoading', true)

      try {
        let batch = firebase.firestore().batch()

        // Save each page to a different company doc
        for (const page of payload.pageData) {
          let companyRef = firebase
            .firestore()
            .collection('companies')
            .doc(page.id)

          // If company exists we update the doc, else we create a new one
          if ((await companyRef.get()).exists) {
            const updateCompany = {
              fbPageToken: page.access_token,
              ownerPageTasks: page.ownerPageTasks
            }
            batch.update(companyRef, updateCompany)
          } else {
            const addCompany = {
              companyId: page.id,
              companyName: page.name,
              creationDate: new Date(),
              fbPageToken: page.access_token,
              ownerId: payload.ownerId,
              ownerPageTasks: page.ownerPageTasks,
              photoUrl: page.photoUrl,
              subscribedLabel: page.subscribedLabel,
              status: page.status
            }

            batch.set(companyRef, addCompany)

            const addBot = {
              creationDate: new Date(),
              companyData: [],
              emails: [payload.email],
              exRate: 0,
              currency: '',
              shippingCost: [{
                zone: '',
                cost: 0
              }],
              ordersCounter: 0
            }

            let botRef = firebase
              .firestore()
              .collection('companies')
              .doc(page.id)
              .collection('bots')
              .doc(constants.BOT_ID)

            batch.set(botRef, addBot)
          }
        }

        await batch.commit()
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Load company to state
     * @param {*} param0
     * @param {*} companyId
     */
    async actionLoadCompany ({ commit }, companyId) {
      try {
        console.log('Loading company: ', companyId)

        const companyDoc = await firebase
          .firestore()
          .collection('companies')
          .doc(companyId)
          .get()

        const companyData = {
          companyId: companyDoc.data().companyId,
          companyName: companyDoc.data().companyName,
          companyStatus: companyDoc.data().status,
          companyPhotoUrl: companyDoc.data().photoUrl
        }

        commit('mutationSetCompanyData', companyData)
      } catch (error) {
        throw error
      }
    },

    /**
     * Loading company data to the state.
     *
     */
    async actionLoadCompanies ({ commit }) {
      // Loading on.
      commit('mutationSetLoading', true)

      try {
        // Get all companies from firestore.
        const companies = []
        const queryCompanies = await firebase
          .firestore()
          .collection('companies')
          .orderBy('companyName')
          .get()

        // Load companies to the state.
        for (const company of queryCompanies.docs) {
          companies.push({
            companyId: company.id,
            photoUrl: company.data().photoUrl,
            companyName: company.data().companyName,
            creationDate: company.data().creationDate,
            status: company.data().status
          })
        }
        commit('mutationLoadedCompanies', companies)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Delete company.
     * @param {*} payload -The companyId
     */
    async actionDeleteCompany ({ commit }, payload) {
      // eslint-disable-next-line
      console.log('payload: ', payload)
      // Delete the company doc from firestore and mutate the state.
      try {
        await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .delete()

        commit('mutationDeleteLoadedCompany', payload.companyId)
      } catch (error) {
        throw error
      }
    },

    /**
     * Add company info to company doc
     * @param {*} payload - companyId.
     */
    async actionSubmitCompanyData ({ commit }, payload) {
      // eslint-disable-next-line
      console.log('payload: ', payload)
      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Store the data in firestore
        await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .update({
            companyData: payload.companyData,
            currency: payload.currency,
            shippingCost: payload.shippingCost,
            exRate: payload.exRate
          })

        commit('mutationLoadBotInfo', payload.companyData)
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
     * Load bot info.
     * @param {*} payload - companyId
     */
    async loadBotInfo ({ commit }, payload) {
      // eslint-disable-next-line
      console.log('loadBotInfo: ', payload)
      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Load data from firestore
        const queryData = await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .get()

        const companyInfo = {
          companyData: queryData.data().companyData,
          currency: queryData.data().currency,
          shippingCost: queryData.data().shippingCost,
          exRate: queryData.data().exRate
        }
        console.log('companyInfo: ', companyInfo)

        commit('mutationLoadBotInfo', companyInfo)
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    }
  },

  getters: {
    /**
     * @returns an array of companies.
     */
    getLoadedCompanies (state) {
      return state.loadedCompanies
    },

    /**
     * @returns an array of companies.
     */
    getCompanyData (state) {
      return state.companyData
    },

    /**
     * @returns the company data.
     */
    getBotInfo (state) {
      return state.companyInfo
    },

    /**
     * @returns the company data.
     */
    getCurrency (state) {
      return state.currency
    }

  }
}
